
        module.exports = __webpack_public_path__ + "assets/images/favicon_fr.69ce6837.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 96,
            height: 96,
            type: "png",
            bytes: 1730,

            toString: function() {
                return src;
            }
        };
    